module.exports = __webpack_public_path__ + "assets/gift-box-bg-4371f834.png";